// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-modal {
  background: white;
  border-radius: 8px;
  padding: 32px 24px;
  width: 100%;
  text-align: center;
  animation: slideUp 0.3s ease;
}
.error-modal .error-icon {
  height: 80px;
  width: 80px;
  margin-bottom: 15px;
}
.error-modal h2 {
  font-family: AppFontBold;
  font-size: 18px;
  line-height: 130%;
  letter-spacing: -0.01em;
  text-align: center;
  margin-bottom: 22px;
}
.error-modal p {
  font-size: 15px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  text-wrap: balance;
  color: #393939;
  margin-bottom: 37px;
}

ion-button {
  width: 85%;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/panic-mode-modal/panic-mode-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;AACD;AACC;EACC,YAAA;EACA,WAAA;EACA,mBAAA;AACF;AAEC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,mBAAA;AADF;AAIC;EACC,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,cAAA;EACA,mBAAA;AAHF;;AAOA;EACC,UAAA;EACA,cAAA;AAJD","sourcesContent":[".error-modal {\n\tbackground: white;\n\tborder-radius: 8px;\n\tpadding: 32px 24px;\n\twidth: 100%;\n\ttext-align: center;\n\tanimation: slideUp 0.3s ease;\n\n\t.error-icon {\n\t\theight: 80px;\n\t\twidth: 80px;\n\t\tmargin-bottom: 15px;\n\t}\n\n\th2 {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 18px;\n\t\tline-height: 130%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-align: center;\n\t\t// text-transform: uppercase;\n\t\tmargin-bottom: 22px;\n\t}\n\n\tp {\n\t\tfont-size: 15px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\n\t\ttext-wrap: balance;\n\t\tcolor: #393939;\n\t\tmargin-bottom: 37px;\n\t}\n}\n\nion-button {\n\twidth: 85%;\n\tmargin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
